const getPartKeys = (store) => {
  return store.partKeys;
};

export { getPartKeys };
